import React from "react";
import Typography from "@mui/material/Typography";

  let dimmedColor = { color: 'rgba(0, 0, 0, 0.4)' };

  export function CollectingInstructions({ instructions, dimm = false }) {
  const textStyle = dimm ? dimmedColor : {};

  return (
    <Typography>
      <span style={textStyle}>You can collect you present </span>
      <span dangerouslySetInnerHTML={{ __html: instructions }} />
      <span style={textStyle}>.</span>
    </Typography>
  );
}

export function DeliveryInstructions({ instructions, dimm = false }) {
  const textStyle = dimm ? dimmedColor : {};

  return (
    <Typography>
      <span style={textStyle}>
        Don't forget to pack present, put receiver's name on it and place the present{' '}
      </span>
      <span dangerouslySetInnerHTML={{ __html: instructions }} />
      <span style={textStyle}>, the sooner the better!</span>
    </Typography>
  );
}

